import { gql } from "graphql-tag";

export const GET_USER_REVIEWS = gql`
query customer_review_list {
  customer_review_list{
      customer{
          firstname
          lastname
          email
      }
      reviews{
          id
          title
          detail
          rating
          percentage
          created_at
          product{
              id
              name
              url
          }
      }
  }
}
`;
export const GET_USER_REVIEWS_DETAIL = gql`
  query customer_review_list($reviewId: Int!) {
    customer_review_view(review_id: $reviewId) {
      reviews {
        id
        title
        detail
        rating
        percentage
        created_at
        rating_summary {
          rating_count
          avg_rating
          avg_percentage
        }
        product {
          id
          name
          url
          image_url
        }
      }
    }
  }
`;
export const ADD_PRODUCT_REVIEW = gql`
mutation ($entityPkValue: String!, $entityType: String!, $nickname: String!, $title: String!, $detail: String!, $ratingId: Int!, $value: Int!, $imageName: String!, $imageFile: String!) {
  submitReview(input: {
    entity_pk_value: $entityPkValue
    entity_type: $entityType
    nickname: $nickname
    title: $title
    detail: $detail
    ratings: {
      rating_id: $ratingId
      value: $value
    }
    images: [
      {
        name: $imageName
        file: $imageFile
      }
    ]
  }) {
    message
    review_id
  }
}
`;